import React, { useState, useEffect } from 'react';
import { Modal, Button, FormInput, FormSelect, RichTextEditor } from '../../../components/ui';

export default function AddTermInfoModal({ isOpen, onClose, onSave, initialData, isViewOnly }) {
  const [formData, setFormData] = useState({
    title: '',
    category: '',
    description: '',
    paymentTitle: 'PAYMENT DETAILS',
    paymentDescription: '',
    status: 'Active',
    isRelatedToAppliances: false
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (initialData) {
      setFormData({
        title: initialData.title || '',
        category: initialData.category || '',
        description: initialData.description || '',
        paymentTitle: initialData.paymentTitle || 'PAYMENT DETAILS',
        paymentDescription: initialData.paymentDescription || '',
        status: initialData.status || 'Active',
        isRelatedToAppliances: initialData.isRelatedToAppliances || false
      });
    } else {
      setFormData({
        title: '',
        category: '',
        description: '',
        paymentTitle: 'PAYMENT DETAILS',
        paymentDescription: '',
        status: 'Active',
        isRelatedToAppliances: false
      });
    }
  }, [initialData, isOpen]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleRichTextChange = (name, value) => {
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isViewOnly) {
      onClose();
      return;
    }
    setLoading(true);
    try {
      const dataToSave = {
        ...formData,
        title: formData.title || 'TERMS AND CONDITIONS',
        paymentTitle: formData.paymentTitle || 'PAYMENT DETAILS',
        category: formData.category || 'General',
      };
      await onSave(dataToSave);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={isViewOnly ? "VIEW TERMS AND CONDITIONS" : initialData ? "EDIT TERMS AND CONDITIONS" : "ADD TERMS AND CONDITIONS"}
      size="2xl"
    >
      <form onSubmit={handleSubmit} className="flex flex-col">
        <div className="space-y-6 pb-4">
          <div className="flex flex-col gap-2">
            <label className="text-sm font-semibold text-slate-700 uppercase tracking-widest text-[10px]">Category</label>
            <div className="flex items-center gap-6">
              {['General', 'Sale Invoice', 'Quotation'].map(cat => (
                <label key={cat} className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="radio"
                    name="category"
                    value={cat}
                    checked={formData.category === cat || (!formData.category && cat === 'General')}
                    onChange={handleChange}
                    disabled={isViewOnly}
                    className="w-4 h-4 text-brand-blue border-gray-300 focus:ring-brand-blue"
                  />
                  <span className="text-sm font-medium text-gray-700">{cat}</span>
                </label>
              ))}
            </div>
          </div>

          <div className="flex items-center gap-2">
            <input
              type="checkbox"
              id="isRelatedToAppliances"
              name="isRelatedToAppliances"
              checked={formData.isRelatedToAppliances}
              onChange={handleChange}
              disabled={isViewOnly}
              className="w-4 h-4 text-brand-blue border-gray-300 rounded focus:ring-brand-blue"
            />
            <label htmlFor="isRelatedToAppliances" className="text-sm font-medium text-gray-700">
              Is Related To Appliances
            </label>
          </div>

          <RichTextEditor
            label="TERMS AND CONDITIONS"
            name="description"
            value={formData.description}
            onChange={(value) => handleRichTextChange('description', value)}
            placeholder="Enter term points here (e.g. 1. ...)"
            disabled={isViewOnly}
            minHeight="160px"
          />

          <RichTextEditor
            label="PAYMENT TERMS"
            name="paymentDescription"
            value={formData.paymentDescription}
            onChange={(value) => handleRichTextChange('paymentDescription', value)}
            placeholder="Enter payment points here (e.g. 1. ...)"
            disabled={isViewOnly}
            minHeight="160px"
          />
        </div>

        <div className="flex items-center justify-end gap-3 pt-4 border-t border-slate-100 mt-2 shrink-0 bg-white">
          <Button type="button" variant="secondary" onClick={onClose}>
            {isViewOnly ? "Close" : "Cancel"}
          </Button>
          {!isViewOnly && (
            <Button type="submit" loading={loading} variant="orange">
              {initialData ? "Update" : "Save"}
            </Button>
          )}
        </div>
      </form>
    </Modal>
  );
}
